import { getPropertiesSearchParams } from '@/components/Dashboard/DashboardPendings/utils';

export const getParsedLabels = (labels, othersText) => {
  const parsedLabels = labels.map((label) =>
    label.isOthers ? { ...label, name: othersText } : label
  );

  return parsedLabels;
};

export const getHeaderUrl = (operationId, statusId, selectedIds) => {
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');
  const searchParams = getPropertiesSearchParams({
    operation_types: [operationId],
    statusId,
    selectedIds,
  });

  return `${tokkoBrokerHost}/properties/?search_options=${searchParams}`;
};

export const handleClickBar = (
  operationId,
  locationId,
  statusId,
  selectedIds
) => {
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');
  const searchParams = getPropertiesSearchParams({
    division_filters: Array.isArray(locationId) ? locationId : [locationId],
    operation_types: [operationId],
    statusId,
    selectedIds,
  });
  const url = `${tokkoBrokerHost}/properties/?search_options=${searchParams}`;
  window.open(url, '_blank');
};

export const handleTooltip = (context, labels, translateTooltip) => {
  const labelIndex = context.dataIndex;
  const label = labels[labelIndex];

  if (!label.isOthers) {
    return `${label.name}: ${label.count}`;
  }

  if (label.isOthers && label.othersDetail) {
    return translateTooltip(label.count, label.locationsCount);
  }

  return `${label.name}: ${label.count}`;
};
